import Card from "../components/Card"
import Image from "../components/Image"

function MessageContainer() {
    return (
        <div className="w-full h-full flex justify-center item-center rounded-3xl"
            style={{ transformStyle: "preserve-3d" }}
        >
            <div className=" w-[20%] h-full flex justify-center item-center" style={{ transformStyle: "preserve-3d" }}
            >
                <Card
                    borderRadius="rounded-3xl"
                    innerContent={<Image containerCss={"rounded-3xl"} imgCss={"rounded-3xl"} src={"https://res.cloudinary.com/dl5mqatis/image/upload/v1648532363/passage/passage-showcase/message-tab-min_gglpzv.png"} />}
                />
            </div>
            <div className="w-[80%] h-full flex justify-center item-center rounded-3xl" style={{ transformStyle: "preserve-3d" }}
            >
                <Card
                    borderRadius="rounded-3xl"
                    innerContent={<Image containerCss={"rounded-3xl"} imgCss={"rounded-3xl"} src={"https://res.cloudinary.com/dl5mqatis/image/upload/v1648532363/passage/passage-showcase/message-main-min_orp0rd.png"} />}
                />
            </div>
        </div>
    )
}

export default MessageContainer